import type { ReadyToPrepareByHourRow } from '../models';
import { hourToRangeSlot, type HourRangeSlot } from './hourRangeBuckets';

export type ClientHourRangeRow = {
  client_team_id: number;
  client_name: string;
  clientLabel: string;
  range_12_14: number;
  range_14_16: number;
  range_16_12: number;
  total: number;
  /** Partes del 100 % para barra apilada (mismo total que los pedidos del cliente). */
  pct_12_14: number;
  pct_14_16: number;
  pct_16_12: number;
};

export function aggregateByClientHourRanges(rows: ReadyToPrepareByHourRow[]): ClientHourRangeRow[] {
  const map = new Map<number, { name: string; range_12_14: number; range_14_16: number; range_16_12: number }>();

  for (const r of rows) {
    const slot: HourRangeSlot = hourToRangeSlot(r.hour);
    const cur = map.get(r.client_team_id);
    if (!cur) {
      const init = {
        name: r.client_name,
        range_12_14: 0,
        range_14_16: 0,
        range_16_12: 0,
      };
      init[slot] = r.order_count;
      map.set(r.client_team_id, init);
    } else {
      cur[slot] += r.order_count;
    }
  }

  return Array.from(map.entries())
    .map(([client_team_id, v]) => {
      const total = v.range_12_14 + v.range_14_16 + v.range_16_12;
      let pct_12_14 = 0;
      let pct_14_16 = 0;
      let pct_16_12 = 0;
      if (total > 0) {
        pct_12_14 = (v.range_12_14 / total) * 100;
        pct_14_16 = (v.range_14_16 / total) * 100;
        pct_16_12 = (v.range_16_12 / total) * 100;
      }
      return {
        client_team_id,
        client_name: v.name,
        clientLabel: v.name.trim(),
        range_12_14: v.range_12_14,
        range_14_16: v.range_14_16,
        range_16_12: v.range_16_12,
        total,
        pct_12_14,
        pct_14_16,
        pct_16_12,
      };
    })
    .sort((a, b) => a.clientLabel.localeCompare(b.clientLabel, undefined, { sensitivity: 'base' }));
}
